<template>
    <v-menu
            ref="menu1"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                    v-model="valueFormatted"
                    :label="label"
                    hint="formát DD.MM.RRRR"
                    persistent-hint
                    prepend-icon="event"
                    @change="emitValue(parseDate(valueFormatted), true)"
                    v-on="on"
                    clearable
            ></v-text-field>
        </template>
        <v-date-picker v-model="valuePicker" no-title
                       @input="emitValue(valuePicker)"
                       locale="cz-CZ" first-day-of-week="1"
        ></v-date-picker>
    </v-menu>
</template>
<script>
    import moment from 'moment'

    export default {
        name: 'CzDatePicker',

        props: {
            value: String,
            label: String
        },

        data: () => ({
            menu: null,
            valueFormatted: '',
            valuePicker: ''
        }),

        watch: {
            value (val) {
                this.valueFormatted = this.formatDate(this.value)
                this.valuePicker = this.value
            }
        },

        methods: {
            emitValue (val /*, input*/) {
                // console.log([this.valuePicker, val, input])
                this.$emit('input', val)
                this.menu = false
            },
            formatDate (date) {
                if (date === '' || date === null) {
                    return ''
                }
                return moment(date).format('DD.MM.YYYY')
            },
            parseDate (date) {
                if (date === '' || date === null) {
                    return ''
                }
                return moment(date, 'DD.MM.YYYY').format('YYYY-MM-DD')
            },
        }
    }
</script>